import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import spacer from './spacer.png'

/**
 *  ExteriorViewAccessories
 */
class ExteriorViewAccessories extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    description: PropTypes.string,
    information: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string,
        text: PropTypes.string,
        id: PropTypes.string,
      }),
    ),
    open: PropTypes.bool,
    isFirst: PropTypes.bool,
    isLast: PropTypes.bool,
    step: PropTypes.number,
    selectedIndex: PropTypes.number,
    selectAccessoryIndex: PropTypes.func,
    closeAccessorySelector: PropTypes.func,
    clearAccessoryIndex: PropTypes.func,
    goToStep: PropTypes.func,
    accessoryLabel: PropTypes.string,
    openAccessoryDetail: PropTypes.func,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    description: null,
    information: null,
    items: null,
    open: null,
    isFirst: null,
    isLast: null,
    step: null,
    selectedIndex: null,
    selectAccessoryIndex: null,
    closeAccessorySelector: null,
    clearAccessoryIndex: null,
    goToStep: null,
    isPrev: null,
    accessoryLabel: null,
    openAccessoryDetail: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      selectedIndex: this.props.selectedIndex,
    }
  }
  
  render() {
    const {
      containerId,
      containerClass,
      description,
      information,
      items,
      isFirst,
      isLast,
      step,
      selectedIndex,
      selectAccessoryIndex,
      closeAccessorySelector,
      clearAccessoryIndex,
      goToStep,
      isPrev,
      accessoryLabel,
      openAccessoryDetail,
    } = this.props;
    
    // 詳細
    const renderDescription = ()=> {
      if (description && description !== '') {
        return (
          <div className="ExteriorViewAccessories__description Wysiwyg">
            <div dangerouslySetInnerHTML={{__html: description}}/>
          </div>
        )
      } else {
        return null;
      }
    };
    
    // アイテム
    const renderItems = ()=> {
      return (
        <ul className="ExteriorViewAccessories__list">
          {items.map((item, index) => {
            if ((!item.text || item.text === '') && (!item.src || item.src === '')) {
              return null;
            } else {
              let name = ' ExteriorViewAccessories__link-';
              if (step === 0) {
                name = name + 'A' + String(index + 1);
              } else if (step === 1) {
                name = name + 'B' + String(index + 1);
              } else if (step === 1) {
                name = name + 'C' + String(index + 1);
              } else if (step === 1) {
                name = name + 'D' + String(index + 1);
              }
              
              const getExtendClass = (index)=> {
                if (this.state.selectedIndex === index) {
                  return ' selected';
                } else if (this.state.selectedIndex !== null && 0 <= this.state.selectedIndex) {
                  return ' unselected';
                } else {
                  return ''
                }
              };
              
              return (
                <li key={index}>
                  <a
                    className={'ExteriorViewAccessories__link' + name + getExtendClass(index)}
                    //href={'#' + item.id}
                    href="javascript:void(0);"
                    onClick={(e) => {
                      e.preventDefault();
                      //
                      this.setState({
                        selectedIndex: index,
                      });
                      //if (selectAccessoryIndex) selectAccessoryIndex(step, index, item.id);
                    }}
                  >
                    {(item.src && item.src !== '') ?
                      <div className="ExteriorViewAccessories__image-wrapper">
                        <div className="ExteriorViewAccessories__image-wrapper2"
                             style={{backgroundImage: 'url(' + item.src + ')'}}>
                          <img className="ExteriorViewAccessories__image" src={spacer} alt=""/>
                        </div>
                      </div>
                      : ''}
                    {(item.text && item.text !== '') ?
                      <div className="ExteriorViewAccessories__paragraph Wysiwyg">
                        <div dangerouslySetInnerHTML={{__html: item.text}}/>
                      </div>
                      : ''}
                  </a>
                </li>
              )
            }
          })}
        </ul>
      )
    };
    
    // 前へ、次へ、決定、ナビゲーション
    const renderNav = ()=> {
      const renderLinkPrev = ()=> {
        if (isFirst ===  true) {
          return (
            <li>
              <a className="ExteriorViewAccessories__link-prev"
                 href="javascript:void(0);"
              >&nbsp;</a></li>
          );
        } else {
          return (
            <li>
              <a className="ExteriorViewAccessories__link-prev"
                 href="javascript:void(0);"
                 onClick={(e) => {
                   e.preventDefault();
                   //
                   if (goToStep) goToStep(step - 1);
                 }}
              ><span>前に戻る</span></a></li>
          )
        }
      };
      const renderLinkNext = ()=> {
        if (isLast === false) {
          return (
            <li>
              <a className={'ExteriorViewAccessories__link-next' + ((this.state.selectedIndex !== null) ? ' active': '')}
                 href="javascript:void(0);"
                 onClick={(e) => {
                   e.preventDefault();
                   //
                   if (selectAccessoryIndex) selectAccessoryIndex(step, this.state.selectedIndex, this.props.items[this.state.selectedIndex].id);
                 }}
              ><span>次のアクセサリーを選択</span></a>
            </li>
          )
        } else {
          return (
            <li>
              <a className={'ExteriorViewAccessories__link-next' + ((this.state.selectedIndex !== null) ? ' active': '')}
                 href="javascript:void(0);"
                 onClick={(e) => {
                   e.preventDefault();
                   //
                   if (selectAccessoryIndex) selectAccessoryIndex(step, this.state.selectedIndex, this.props.items[this.state.selectedIndex].id);
                 }}
              ><span>360°Viewで見る</span></a>
            </li>
          )
        }
      };
      const renderLinkClear = () => {
        if (isFirst ===  false || this.state.selectedIndex !== null) {
          return (
            <li>
              <a className="ExteriorViewAccessories__link-clear"
                 href="javascript:void(0)"
                 onClick={(e) => {
                   e.preventDefault();
                   if (clearAccessoryIndex) clearAccessoryIndex();
                 }}
              >
                {'全選択解除'}
              </a>
            </li>
          )
        } else {
          return (
            <li/>
          )
        }
        // if (isFirst ===  true) {
        //   return (
        //     <li>
        //       <a className="ExteriorViewAccessories__link-clear"
        //          href="javascript:void(0)"
        //          onClick={(e) => {
        //            e.preventDefault();
        //            if (clearAccessoryIndex) clearAccessoryIndex();
        //            if (closeAccessorySelector) closeAccessorySelector();
        //          }}
        //       >
        //         {'全選択解除'}
        //       </a>
        //     </li>
        //   )
        // } else {
        //   return (
        //     <li>
        //       <a className="ExteriorViewAccessories__link-clear"
        //          href="javascript:void(0)"
        //          onClick={(e) => {
        //            e.preventDefault();
        //            if (clearAccessoryIndex) clearAccessoryIndex();
        //          }}
        //       >
        //         {'全選択解除'}
        //       </a>
        //     </li>
        //   )
        // }
        
      };
      return (
        <ul className="ExteriorViewAccessories__list-nav">
          {renderLinkPrev()}
          {renderLinkNext()}
          {renderLinkClear()}
        </ul>
      )
    };
    
    // アクセサリ詳細
    const renderLinkDetail = () => {
      if (accessoryLabel && accessoryLabel !== '') {
        return (
          <a className="ExteriorViewAccessories__link-detail"
             href="javascript:void(0)"
             onClick={(e) => {
               e.preventDefault();
               if (openAccessoryDetail) openAccessoryDetail();
             }}
          >
            {accessoryLabel}
          </a>
        )
      } else {
        return null;
      }
    };
    
    // インフォメーション
    const renderInformation = ()=> {
      if (information && information !== '') {
        return (
          <div className="ExteriorViewAccessories__information Wysiwyg">
            <div dangerouslySetInnerHTML={{__html: information}}/>
          </div>
        )
      } else {
        return null;
      }
    };
    
    // 開くクラス取得
    const getOpenClass = ()=> {
      if (this.props.open === true) {
        if (this.props.isPrev === true) {
          return ' prev';
        } else {
          return ' next';
        }
      } else {
        return '';
      }
    };
    
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        {/*<div className={'ExteriorViewAccessories' + ((this.props.open === true) ? ' open': '')}>*/}
        <div className={'ExteriorViewAccessories' + getOpenClass()}>
  
          {renderDescription()}
  
          {renderItems()}
  
          {renderNav()}
  
          <div className="ExteriorViewAccessories__container">
  
            {renderLinkDetail()}
  
          </div>
  
          {renderInformation()}
  
        </div>
      </Wrapper>
    )
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedIndex: nextProps.selectedIndex,
    });
  }
  
}

export default ExteriorViewAccessories;



// WEBPACK FOOTER //
// ./src/containers/exterior-view-accessories/index.jsx